import React from "react";
import { Tag } from "antd";

export default function Status({
  name,
  type,
  icon,
  onClick,
  color,
  customStyle,
}) {
  let value = null;
  if (name && typeof name === "string") {
    if (
      name.toLowerCase().includes("completed") ||
      name.toLowerCase().includes("collaboration") ||
      name.toLowerCase().includes("guangzhou") ||
      name.toLowerCase() === "payment"
    ) {
      value = { name: name, color: "#237804" };
    } else if (
      name.toLowerCase().includes("pending") ||
      name.toLowerCase().includes("proposed") ||
      name.toLowerCase().includes("loading")
    ) {
      value = { name: name, color: "#8c8c8c" };
    } else if (
      name.toLowerCase().includes("processing") ||
      name.toLowerCase().includes("initiated") ||
      name.toLowerCase().includes("debit")
    ) {
      value = { name: name, color: "#d48806" };
    } else if (name.toLowerCase().includes("partially")) {
      value = { name: name, color: "#76a200" };
    } else if (name.toLowerCase().includes("hold")) {
      value = { name: name, color: "#F8DDA7" };
    } else if (name.toLowerCase().includes("received in bd airport")) {
      value = { name: name, color: "#ad2102" };
    } else if (
      name.toLowerCase().includes("received in bd warehouse") ||
      name.toLowerCase().includes("bank") ||
      name.toLowerCase().includes("shipment") ||
      name.toLowerCase().includes("sea")
    ) {
      value = { name: name, color: "#096dd9" };
    } else if (name.toLowerCase().includes("collect from bd warehouse")) {
      value = { name: name, color: "#9e1068" };
    } else if (name.toLowerCase().includes("on the way to delivery")) {
      value = { name: name, color: "#391085" };
    } else if (
      name.toLowerCase().includes("completed") ||
      name.toLowerCase().includes("approved")
    ) {
      value = { name: name, color: "#3f6600" };
    } else if (
      name.toLowerCase().includes("cancelled") ||
      name.toLowerCase().includes("failed") ||
      name.toLowerCase().includes("denied") ||
      name.toLowerCase().includes("returned") ||
      name.toLowerCase().includes("offer") ||
      name.toLowerCase() === "urgent purchase"
    ) {
      value = { name: name, color: "#a8071a" };
    } else if (name.toLowerCase().includes("repurchase")) {
      value = { name: name, color: "#780650" };
    } else if (name.toLowerCase().includes("rocket")) {
      value = { name: name, color: "#89288F" };
    } else if (name.toLowerCase().includes("bkash")) {
      value = { name: name, color: "#E3106E" };
    } else if (
      name.toLowerCase().includes("ssl") ||
      name.toLowerCase().includes("sundarban")
    ) {
      value = { name: name, color: "#22639C" };
    } else if (name.toLowerCase().includes("balance")) {
      value = { name: name, color: "#000" };
    } else if (name.toLowerCase().includes("nagad")) {
      value = { name: name, color: "#C6000B" };
    } else if (name.toLowerCase().includes("cash")) {
      value = { name: name, color: "#0F67B1" };
    } else if (name.toLowerCase().includes("balance")) {
      value = { name: name, color: "#219C90" };
    } else if (name.toLowerCase().includes("1688")) {
      value = { name: name, color: "#ad2102" };
    } else if (name.toLowerCase().includes("alibaba")) {
      value = { name: name, color: "#FF4D74" };
    } else if (name.toLowerCase().includes("guangzhou")) {
      value = { name: name, color: "#4F709C" };
    } else if (name.toLowerCase().includes("hongkong")) {
      value = { name: name, color: "#B04759" };
    } else if (name.toLowerCase().includes("steadfast")) {
      value = { name: name, color: "#1DC68C" };
    } else if (name.toLowerCase() === "purchasing") {
      value = { name: name, color: "#973131" };
    } else {
      value = { name: name, color: "#212A3E" };
    }
  }
  return (
    <div style={{ position: "relative" }}>
      {value ? (
        <Tag
          style={
            type === "payment_method"
              ? {
                  cursor: "pointer",
                  textTransform: "capitalize",
                  marginRight: "0.5rem",
                  marginBottom: "0.5rem",
                  fontSize: 13,
                }
              : customStyle
                ? customStyle
                : {
                    cursor: "pointer",
                    textTransform: "capitalize",
                    fontSize: 13,
                  }
          }
          icon={icon}
          onClick={() => {
            if (onClick) {
              onClick();
            }
          }}
          color={color ? color : value.color}
        >
          {value.name}
        </Tag>
      ) : (
        "--"
      )}
    </div>
  );
}
